export default __webpack_public_path__ + "static/media/forget-password-illustration.5654c56c.svg";